import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

const messages = {

  pt: {
    cursos: 'Cursos',
    menu: {
      simulados: 'Simulados',
      quizzes: 'Quizzes'
    },
    artigos: 'Artigos',
    categorias: 'Categorias',
    sistemas: 'Sistemas',
    disciplinas: 'Disciplinas',
    irParaCursoLink: 'Ir para o curso',
    videos: 'Videos',
    horas: 'Horas',
    resumos: 'Resumos',
    ementa: 'Ementa',
    professores: 'Professores',
    placeholder: {
      pesquisacurso: 'Busque pelo curso desejado',
      pesquisasimulado: 'Busque pelo simulado desejado',
      pesquisaquizz: 'Busque pelo quiz desejado'
    },
    perfil: {
      meusdados: 'Meus dados',
      dadosacesso: 'Dados de acesso',
      dadospessoais: 'Dados pessoais',
      dadosacademicos: 'Dados acadêmicos',
      tutor: 'Tutor(a)'
    },
    simulados: {
      modoprova: 'Modo Prova',
      modoprovadescricao: 'Pra você que quer se testar de verdade! Simule uma situação de prova e aprenda a lidar com a pressão!',
      modoprovaimagemalt: 'Simulado em modo de prova',
      modotreino: 'Modo Prática',
      modotreinodescricao: 'Veja os comentários em cada questão, sem se preocupar com o tempo. Ideal para você que quer exercitar seu conhecimento de forma livre.',
      modotreinoimagemalt: 'Simulado em modo de prática'
    },
    btn: {
      editar: 'Editar'
    },
    bibliotecaA: 'Biblioteca A'
  },
  en: {
    cursos: 'Courses',
    menu: {
      simulados: 'Tests'
    },
    artigos: 'Articles',
    categorias: 'Categories',
    sistemas: 'Systems',
    disciplinas: 'Subjects',
    irParaCursoLink: 'Go to the course',
    videos: 'Videos',
    horas: 'Hours',
    resumos: 'Summaries',
    ementa: 'Course Program',
    professores: 'Teachers',
    placeholder: {
      pesquisacurso: 'Search for the course',
      pesquisasimulado: 'Search for the practice test'
    },
    perfil: {
      meusdados: 'My profile',
      dadosacesso: 'Access data',
      dadospessoais: 'Personal data',
      dadosacademicos: 'Academic data',
      tutor: 'Tutor'
    },
    simulados: {
      modoprova: 'Trial Mode',
      modoprovadescricao: 'For you who want to really test yourself! Simulate a test situation and learn how to handle the pressure!',
      modoprovaimagemalt: 'Test in trial mode',
      modotreino: 'Practice Mode',
      modotreinodescricao: 'See the comments on each question without worrying about the time. Ideal for you who want to exercise your knowledge freely.',
      modotreinoimagemalt: 'Test in practice mode'
    },
    btn: {
      editar: 'Edit'
    },
    bibliotecaA: 'Biblioteca A'
  }

}

const i18n = new VueI18n({
  locale: 'pt',
  fallbackLocale: 'pt',
  messages
})

export default i18n
